module.exports = __webpack_public_path__ + "img/cartaz-mobile.8d880c0b.jpg";